/**
 * Shopify Theme Asset: assets/shopify-personalizer.js
 */

(function() {  
  'use strict';

  // Prevent multiple script initialization
  if (window.__shopifyPersonalizerInitialized) return;
  window.__shopifyPersonalizerInitialized = true;

  // --- CLOUDINARY CONFIGURATION ---
  const CLOUD_CONFIG = {
    cloudName: 'kx4yx9co',
    uploadPreset: 'shopify_preset'
  };

  /**
   * Uploads a File or Blob directly to Cloudinary Unsigned Upload
   */
  async function uploadFileToCloud(file, resourceType = 'image') {
    if (!CLOUD_CONFIG.cloudName || !CLOUD_CONFIG.uploadPreset) {
      return URL.createObjectURL(file);
    }

    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', CLOUD_CONFIG.uploadPreset);

      const endpoint = `https://api.cloudinary.com/v1_1/${CLOUD_CONFIG.cloudName}/${resourceType}/upload`;
      const res = await fetch(endpoint, { method: 'POST', body: formData });
      const data = await res.json();
      
      if (data.error) {
        console.warn('Cloudinary upload warning:', data.error.message);
        return URL.createObjectURL(file);
      }
      return data.secure_url || data.url;
    } catch (err) {
      console.warn('Cloudinary upload network exception:', err);
      return URL.createObjectURL(file);
    }
  }

  class ShopifyProductPersonalizer {
    constructor() {
      this.root = document.getElementById('shopify-personalizer-root');
      if (!this.root) return;

      const urlParams = new URLSearchParams(window.location.search);
      this.productHandle = urlParams.get('product') || '';
      this.targetVariantId = urlParams.get('variant') || '';

      const initialCat = (urlParams.get('category') || '').toLowerCase().replace(/[-_\s]+/g, '');
      if (['noaudionew', 'audioimage', 'noaudiofamily', 'audionew', 'cards', 'mealtime', 'audio', 'bespoke'].includes(initialCat)) {
        this.category = initialCat;
      } else {
        this.category = 'noaudionew';
      }

      this.product = null;
      this.selectedVariant = null;
      this.isSubmitting = false;

      this.state = {
        name: '',
        gender: 'Boy',
        notes: '',
        photos: [],        // Cards (max 10) & Audio (max 5)
        soloPhotos: [],    // Mealtime Child Solo Photos (max 10)
        familyPhotos: [],  // Mealtime Family Photos (max 5)
        childPhoto: null,  // Bespoke Child Portrait
        audio: null,       // Audio Pronunciation
        errors: {}
      };

      this.mediaRecorder = null;
      this.audioChunks = [];
      this.activePreviewCardIndex = 0;
      this.activeSoloPhotoIndex = 0;
      this.activeFamilyPhotoIndex = 0;
      this.zoomScale = 1;
      this.zoomPhotoIndex = 0;
      this.currentZoomPhotoList = [];

      this.initDOMElements();
      this.switchCategoryFieldView();
      this.bindEvents();
      this.initZoomModal();
      this.loadProductData();
    }

    initDOMElements() {
      this.panelForm = document.getElementById('panel-form-view');
      this.panelSample = document.getElementById('panel-sample-view');
      this.step1 = document.getElementById('step-indicator-1');
      this.step2 = document.getElementById('step-indicator-2');
      this.step3 = document.getElementById('step-indicator-3');
      this.form = document.getElementById('shopify-personalization-form');
      this.btnCheckSample = document.getElementById('btn-trigger-check-sample');

      this.btnSampleEditTop = document.getElementById('btn-sample-edit-top');
      this.btnSampleEditMain = document.getElementById('btn-sample-edit-main');
      this.btnSampleAddCartTop = document.getElementById('btn-sample-add-cart-top');
      this.btnSampleAddCartMain = document.getElementById('btn-sample-add-cart-main');

      this.summaryTitle = document.getElementById('summary-prod-title');
      this.summaryType = document.getElementById('summary-prod-type');
      this.summaryPrice = document.getElementById('summary-variant-price');
      this.summaryVariantTitle = document.getElementById('summary-variant-title');
      this.summaryImg = document.getElementById('summary-prod-img');
      this.summaryPlaceholder = document.getElementById('summary-thumb-placeholder');
      this.summaryBackLink = document.getElementById('summary-back-link');
      this.formVariantInput = document.getElementById('form-variant-id');
      this.formVariantMetafield = document.getElementById('viewport_metafiled_slider');
    }

    /* --------------------------------------------------------------------------
       Lightbox Zoom & Image Magnifier Modal
       -------------------------------------------------------------------------- */
    initZoomModal() {
      let modal = document.getElementById('personalizer-zoom-modal');
      if (!modal) {
        modal = document.createElement('div');
        modal.id = 'personalizer-zoom-modal';
        modal.className = 'personalizer-zoom-modal-backdrop';
        modal.innerHTML = `
          <div class="zoom-modal-container">
            <div class="zoom-modal-header">
              <div class="zoom-meta-info">
                <span class="zoom-title" id="zoom-modal-title">HD Image Magnifier</span>
                <span class="zoom-counter" id="zoom-modal-counter">Photo 1 of 1</span>
              </div>
              <div class="zoom-toolbar">
                <button type="button" class="btn-zoom-tool" id="btn-zoom-in" title="Zoom In">🔍 +</button>
                <button type="button" class="btn-zoom-tool" id="btn-zoom-out" title="Zoom Out">🔍 -</button>
                <button type="button" class="btn-zoom-tool" id="btn-zoom-reset" title="Reset Zoom">🔄 Reset</button>
                <button type="button" class="btn-zoom-tool btn-zoom-close" id="btn-zoom-close" title="Close">✕</button>
              </div>
            </div>

            <div class="zoom-modal-viewport" id="zoom-viewport">
              <img src="" alt="Zoomed Image" id="zoom-modal-img" class="zoom-modal-img" />
              <button type="button" class="btn-zoom-nav btn-zoom-prev" id="btn-zoom-prev" title="Previous Image">‹</button>
              <button type="button" class="btn-zoom-nav btn-zoom-next" id="btn-zoom-next" title="Next Image">›</button>
            </div>

            <div class="zoom-modal-footer">
              <span>💡 Scroll mouse wheel or use zoom buttons to inspect fine details. Use Arrow keys to navigate.</span>
            </div>
          </div>
        `;
        document.body.appendChild(modal);

        const zoomImg = document.getElementById('zoom-modal-img');
        const btnClose = document.getElementById('btn-zoom-close');
        const btnIn = document.getElementById('btn-zoom-in');
        const btnOut = document.getElementById('btn-zoom-out');
        const btnReset = document.getElementById('btn-zoom-reset');
        const btnPrev = document.getElementById('btn-zoom-prev');
        const btnNext = document.getElementById('btn-zoom-next');

        const updateZoomTransform = () => {
          if (zoomImg) zoomImg.style.transform = `scale(${this.zoomScale})`;
        };

        btnIn?.addEventListener('click', () => {
          this.zoomScale = Math.min(3.5, this.zoomScale + 0.3);
          updateZoomTransform();
        });

        btnOut?.addEventListener('click', () => {
          this.zoomScale = Math.max(0.6, this.zoomScale - 0.3);
          updateZoomTransform();
        });

        btnReset?.addEventListener('click', () => {
          this.zoomScale = 1;
          updateZoomTransform();
        });

        const closeZoom = () => {
          modal.classList.remove('active');
          this.zoomScale = 1;
          updateZoomTransform();
        };

        btnClose?.addEventListener('click', closeZoom);
        modal.addEventListener('click', (e) => {
          if (e.target === modal) closeZoom();
        });

        btnPrev?.addEventListener('click', () => {
          const list = this.currentZoomPhotoList || this.state.photos;
          if (list.length > 0) {
            this.zoomPhotoIndex = (this.zoomPhotoIndex - 1 + list.length) % list.length;
            this.openZoomModal(list[this.zoomPhotoIndex].url, list[this.zoomPhotoIndex].name, this.zoomPhotoIndex, list);
          }
        });

        btnNext?.addEventListener('click', () => {
          const list = this.currentZoomPhotoList || this.state.photos;
          if (list.length > 0) {
            this.zoomPhotoIndex = (this.zoomPhotoIndex + 1) % list.length;
            this.openZoomModal(list[this.zoomPhotoIndex].url, list[this.zoomPhotoIndex].name, this.zoomPhotoIndex, list);
          }
        });

        document.addEventListener('keydown', (e) => {
          if (!modal.classList.contains('active')) return;
          if (e.key === 'Escape') closeZoom();
          if (e.key === 'ArrowLeft') btnPrev?.click();
          if (e.key === 'ArrowRight') btnNext?.click();
        });

        zoomImg?.parentElement?.addEventListener('wheel', (e) => {
          e.preventDefault();
          this.zoomScale = (e.deltaY < 0) ? Math.min(3.5, this.zoomScale + 0.15) : Math.max(0.6, this.zoomScale - 0.15);
          updateZoomTransform();
        });
      }
    }

    openZoomModal(imageUrl, title = 'Photo Detail', photoIndex = 0, photoList = null) {
      this.initZoomModal();
      const modal = document.getElementById('personalizer-zoom-modal');
      const img = document.getElementById('zoom-modal-img');
      const titleEl = document.getElementById('zoom-modal-title');
      const counterEl = document.getElementById('zoom-modal-counter');
      const btnPrev = document.getElementById('btn-zoom-prev');
      const btnNext = document.getElementById('btn-zoom-next');

      this.currentZoomPhotoList = photoList || this.state.photos;

      if (modal && img) {
        this.zoomScale = 1;
        this.zoomPhotoIndex = photoIndex;
        img.src = imageUrl;
        img.style.transform = 'scale(1)';
        if (titleEl) titleEl.textContent = title;
        
        const total = this.currentZoomPhotoList.length;
        if (counterEl) counterEl.textContent = total > 1 ? `Image ${photoIndex + 1} of ${total}` : 'HD View';
        if (btnPrev && btnNext) {
          btnPrev.style.display = total > 1 ? 'flex' : 'none';
          btnNext.style.display = total > 1 ? 'flex' : 'none';
        }

        modal.classList.add('active');
      }
    }

    /* --------------------------------------------------------------------------
       Product Hydration from URL
       -------------------------------------------------------------------------- */
    async loadProductData() {
      if (!this.productHandle) return;

      try {
        const response = await fetch(`/products/${this.productHandle}.js`);
        if (!response.ok) throw new Error('Product not found');
        
        this.product = await response.json();
        this.detectCategory();
        this.resolveVariant();
        this.updateSummaryUI();
        this.switchCategoryFieldView();
      } catch (err) {
        console.warn(`Could not fetch product JSON from /products/${this.productHandle}.js`, err);
        if (this.summaryTitle) {
          this.summaryTitle.textContent = this.productHandle.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        }
      }
    }

    detectCategory() {
      if (!this.product) return;
      const typeLower = (this.product.type || '').toLowerCase().trim();
      const handle = (this.product.handle || '').toLowerCase().trim();

      // Normalize all tags: remove "tag:", "type:", "and", "&", "+", dashes, underscores, and whitespace
      const normalizedTags = (this.product.tags || []).map(t => {
        return (t || '')
          .toLowerCase()
          .replace(/^(tag:|type:)/, '')
          .replace(/&(amp;)?|\+|\band\b/g, '')
          .replace(/[-_\s]+/g, '')
          .trim();
      });

      console.log('[Shopify Personalizer] Product Handle:', handle);
      console.log('[Shopify Personalizer] Raw Tags:', this.product.tags);
      console.log('[Shopify Personalizer] Normalized Tags:', normalizedTags);

      const urlParams = new URLSearchParams(window.location.search);
      const urlCat = (urlParams.get('category') || urlParams.get('tag') || '').toLowerCase().replace(/&(amp;)?|\+|\band\b/g, '').replace(/[-_\s]+/g, '');

      // Priority 0: Explicit URL parameter override for instant testing (?category=... or ?tag=...)
      if (['noaudionew', 'audioimage', 'noaudiofamily', 'audionew', 'cards', 'mealtime', 'audio', 'bespoke'].includes(urlCat)) {
        this.category = urlCat;
      // Priority 1: Exact Tag Requirements from Shopify Product Tags
      } else if (normalizedTags.includes('audioimage')) {
        this.category = 'audioimage';
      } else if (normalizedTags.includes('noaudionew')) {
        this.category = 'noaudionew';
      } else if (normalizedTags.includes('noaudiofamily')) {
        this.category = 'noaudiofamily';
      } else if (normalizedTags.includes('audionew')) {
        this.category = 'audionew';
      // Priority 2: Semantic / Product Type / Legacy Fallbacks
      } else if (normalizedTags.includes('mealtime') || typeLower.includes('meal') || handle.includes('meal') || handle.includes('plate')) {
        this.category = 'noaudiofamily';
      } else if (normalizedTags.includes('bespoke') || typeLower.includes('bespoke') || handle.includes('bespoke') || handle.includes('keepsake')) {
        this.category = 'audioimage';
      } else if (normalizedTags.includes('audio') || typeLower.includes('audio') || handle.includes('audio') || handle.includes('sleep') || handle.includes('yoga')) {
        this.category = 'audionew';
      } else if (normalizedTags.includes('cards') || typeLower.includes('card') || handle.includes('card')) {
        this.category = 'noaudionew';
      } else {
        this.category = 'noaudionew';
      }

      console.log('[Shopify Personalizer] Selected Category:', this.category);

      const propType = document.getElementById('prop-product-type');
      if (propType) propType.value = this.category;
    }

    resolveVariant() {
      if (!this.product || !this.product.variants) return;
      const targetId = parseInt(this.targetVariantId, 10);
      this.selectedVariant = this.product.variants.find(v => v.id === targetId) || this.product.variants[0];
      if (this.formVariantInput && this.selectedVariant) {
        this.formVariantInput.value = this.selectedVariant.id;
      }
    }

    updateSummaryUI() {
      if (!this.product) return;
      if (this.summaryTitle) this.summaryTitle.textContent = this.product.title;
      if (this.summaryType) this.summaryType.textContent = this.product.type || `${this.category.toUpperCase()} CATEGORY`;
      if (this.summaryBackLink) this.summaryBackLink.href = `/products/${this.product.handle}`;
      
      if (this.selectedVariant) {
        if (this.summaryPrice) {
          this.summaryPrice.textContent = `$${(this.selectedVariant.price / 100).toFixed(2)}`;
        }
        if (this.summaryVariantTitle) {
          this.summaryVariantTitle.innerHTML = `Selected Edition: <strong>${this.selectedVariant.title}</strong>`;
        }
      }

      const featuredImage = this.product.featured_image || this.product.images?.[0];
      if (featuredImage && this.summaryImg) {
        this.summaryImg.src = featuredImage;
        this.summaryImg.style.display = 'block';
        if (this.summaryPlaceholder) this.summaryPlaceholder.style.display = 'none';
      }
    }

    switchCategoryFieldView() {
      const fieldContainers = {
        audionew: document.getElementById('fields-audionew'),
        noaudionew: document.getElementById('fields-noaudionew'),
        noaudiofamily: document.getElementById('fields-noaudiofamily'),
        audioimage: document.getElementById('fields-audioimage'),
        cards: document.getElementById('fields-cards'),
        mealtime: document.getElementById('fields-mealtime'),
        audio: document.getElementById('fields-audio'),
        bespoke: document.getElementById('fields-bespoke')
      };

      const activeKey = fieldContainers[this.category] ? this.category : (
        this.category === 'audionew' ? 'audio' :
        this.category === 'noaudionew' ? 'cards' :
        this.category === 'noaudiofamily' ? 'mealtime' :
        this.category === 'audioimage' ? 'audio' : 'cards'
      );

      Object.keys(fieldContainers).forEach(key => {
        if (fieldContainers[key]) {
          fieldContainers[key].style.display = (key === activeKey) ? 'block' : 'none';
        }
      });

      // Clear any leftover visible errors when switching categories
      this.root.querySelectorAll('.field-error-text').forEach(el => {
        el.textContent = '';
        el.classList.remove('visible');
      });
    }

    bindEvents() {
      // Recipient / Child Name fields across all category forms
      this.root.querySelectorAll('input[name="properties[Personalized Name]"]').forEach(input => {
        input.addEventListener('input', (e) => {
          this.state.name = e.target.value;

          // Sync value across all category name inputs
          this.root.querySelectorAll('input[name="properties[Personalized Name]"]').forEach(otherInput => {
            if (otherInput !== input) otherInput.value = this.state.name;
          });

          // Sync character count in each name card
          this.root.querySelectorAll('.name-card').forEach(nameCard => {
            const counter = nameCard.querySelector('.char-count');
            const cardInput = nameCard.querySelector('input[name="properties[Personalized Name]"]');
            if (counter && cardInput) {
              const max = cardInput.getAttribute('maxlength') || '30';
              counter.textContent = `${this.state.name.length} / ${max}`;
            }
          });

          if (this.state.errors.name) {
            delete this.state.errors.name;
            this.clearFieldError('name');
          }
        });
      });

      // Gender / Theme Radio Options
      const radioLabels = this.root.querySelectorAll('.option-pill-label');
      radioLabels.forEach(label => {
        label.addEventListener('click', () => {
          const parentGroup = label.closest('.options-pill-grid');
          if (parentGroup) {
            parentGroup.querySelectorAll('.option-pill-label').forEach(l => l.classList.remove('selected'));
          }
          label.classList.add('selected');
          const radio = label.querySelector('input[type="radio"]');
          if (radio) {
            radio.checked = true;
            this.state.gender = radio.value;
          }
        });
      });

      // Customer Notes
      const notesInput = document.getElementById('input-customer-notes');
      const notesCounter = document.getElementById('notes-char-count');
      if (notesInput) {
        notesInput.addEventListener('input', (e) => {
          this.state.notes = e.target.value;
          if (notesCounter) notesCounter.textContent = `${this.state.notes.length} / 300`;
        });
      }

      // 1. Tag: noaudionew & Legacy Cards Uploader (Max 10)
      this.bindPhotoUploader('noaudionew-photo-dropzone', 'noaudionew-photo-input', 'noaudionew-thumbnails-grid', 'noaudionew-photo-counter', 10, 'photos', 'photos', 'photos');
      this.bindPhotoUploader('cards-photo-dropzone', 'cards-photo-input', 'cards-thumbnails-grid', 'cards-photo-counter', 10, 'photos', 'photos', 'photos');

      // 2. Tag: noaudiofamily & Legacy Mealtime (Solo max 10, Family max 5)
      this.bindPhotoUploader('noaudiofamily-solo-photo-dropzone', 'noaudiofamily-solo-photo-input', 'noaudiofamily-solo-thumbnails-grid', 'noaudiofamily-solo-photo-counter', 10, 'soloPhotos', 'photos', 'soloPhotos');
      this.bindPhotoUploader('mealtime-solo-photo-dropzone', 'mealtime-solo-photo-input', 'mealtime-solo-thumbnails-grid', 'mealtime-solo-photo-counter', 10, 'soloPhotos', 'solo photos', 'soloPhotos');

      this.bindPhotoUploader('noaudiofamily-family-photo-dropzone', 'noaudiofamily-family-photo-input', 'noaudiofamily-family-thumbnails-grid', 'noaudiofamily-family-photo-counter', 5, 'familyPhotos', 'family photos', 'familyPhotos');
      this.bindPhotoUploader('mealtime-family-photo-dropzone', 'mealtime-family-photo-input', 'mealtime-family-thumbnails-grid', 'mealtime-family-photo-counter', 5, 'familyPhotos', 'family photos', 'familyPhotos');

      // 3. Tag: audioimage & Legacy Audio Photos (Max 5)
      this.bindPhotoUploader('audioimage-photo-dropzone', 'audioimage-photo-input', 'audioimage-thumbnails-grid', 'audioimage-photo-counter', 5, 'photos', 'photos', 'photos');
      this.bindPhotoUploader('audio-photo-dropzone', 'audio-photo-input', 'audio-thumbnails-grid', 'audio-photo-counter', 5, 'photos', 'photos', 'photos');

      // 4. Bespoke Child Portrait
      this.bindBespokeUploader();

      // 5. Audio Pronunciation Handlers (audionew, audioimage, audio)
      this.bindAudioSection('audionew');
      this.bindAudioSection('audioimage');
      this.bindAudioSection('audio');

      // CTA and Stepper Navigation
      if (this.btnCheckSample) {
        this.btnCheckSample.addEventListener('click', () => {
          if (this.validate()) this.showSampleProof();
        });
      }

      [this.btnSampleEditTop, this.btnSampleEditMain].forEach(btn => {
        if (btn) btn.addEventListener('click', () => this.showFormView());
      });

      [this.btnSampleAddCartTop, this.btnSampleAddCartMain].forEach(btn => {
        if (btn) btn.addEventListener('click', () => this.submitToShopifyCart());
      });
    }

    /* --------------------------------------------------------------------------
       Generic Photo Uploader Binding
       -------------------------------------------------------------------------- */
    bindPhotoUploader(dropzoneId, inputId, gridId, counterId, maxLimit, stateKey, unitLabel, errorKey) {
      const dropzone = document.getElementById(dropzoneId);
      const fileInput = document.getElementById(inputId);
      const grid = document.getElementById(gridId);
      const counter = document.getElementById(counterId);

      if (!dropzone && !fileInput) return;

      const handleFiles = (files) => {
        const list = Array.from(files);
        const currentList = this.state[stateKey];

        if (currentList.length + list.length > maxLimit) {
          this.showFieldError(errorKey, `Maximum ${maxLimit} ${unitLabel} allowed.`);
          return;
        }

        list.forEach(file => {
          const isImg = file.type.startsWith('image/') || /\.(png|jpe?g|webp|gif|heic|avif|bmp)$/i.test(file.name);
          if (!isImg) {
            this.showFieldError(errorKey, 'Please upload valid image files (PNG, JPG, WebP).');
            return;
          }
          const reader = new FileReader();
          reader.onload = (e) => {
            currentList.push({
              name: file.name,
              file: file,
              size: (file.size / (1024 * 1024)).toFixed(1) + ' MB',
              url: e.target.result
            });
            this.renderPhotoThumbnails(grid, counter, maxLimit, currentList, stateKey, unitLabel);
            this.clearFieldError(errorKey);
          };
          reader.readAsDataURL(file);
        });

        if (fileInput) fileInput.value = '';
      };

      if (fileInput) fileInput.addEventListener('change', (e) => handleFiles(e.target.files));
      this.bindDragDrop(dropzone, handleFiles);
    }

    /* --------------------------------------------------------------------------
       Audio Helpers & Duration Calculation
       -------------------------------------------------------------------------- */
    formatTime(seconds) {
      if (isNaN(seconds) || seconds < 0 || !isFinite(seconds)) return '0:00';
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    }

    getAudioDuration(fileOrBlob, fallbackSec = 0) {
      return new Promise((resolve) => {
        if (fallbackSec && fallbackSec > 0) {
          resolve(fallbackSec);
          return;
        }

        try {
          const url = URL.createObjectURL(fileOrBlob);
          const audio = new Audio();
          audio.preload = 'metadata';
          let done = false;

          const finish = (duration) => {
            if (!done) {
              done = true;
              try { URL.revokeObjectURL(url); } catch (e) {}
              resolve(duration > 0 && isFinite(duration) ? duration : (fallbackSec || 0));
            }
          };

          audio.addEventListener('loadedmetadata', () => {
            if (isFinite(audio.duration) && audio.duration > 0) {
              finish(audio.duration);
            }
          });

          audio.addEventListener('durationchange', () => {
            if (isFinite(audio.duration) && audio.duration > 0) {
              finish(audio.duration);
            }
          });

          audio.addEventListener('error', () => {
            tryAudioContext();
          });

          const tryAudioContext = () => {
            if (done) return;
            const AudioContextClass = window.AudioContext || window.webkitAudioContext;
            if (AudioContextClass) {
              const reader = new FileReader();
              reader.onload = (e) => {
                try {
                  const ctx = new AudioContextClass();
                  ctx.decodeAudioData(e.target.result.slice(0), (buf) => {
                    ctx.close().catch(() => {});
                    if (buf && buf.duration) {
                      finish(buf.duration);
                    } else {
                      finish(fallbackSec);
                    }
                  }, () => finish(fallbackSec));
                } catch (err) {
                  finish(fallbackSec);
                }
              };
              reader.onerror = () => finish(fallbackSec);
              reader.readAsArrayBuffer(fileOrBlob);
            } else {
              finish(fallbackSec);
            }
          };

          setTimeout(() => {
            if (!done) {
              tryAudioContext();
              setTimeout(() => finish(fallbackSec), 800);
            }
          }, 500);

          audio.src = url;
        } catch (e) {
          resolve(fallbackSec || 0);
        }
      });
    }

    /* --------------------------------------------------------------------------
       Modular Audio Pronunciation Section Binder
       -------------------------------------------------------------------------- */
    bindAudioSection(prefix) {
      const fileInput = document.getElementById(`${prefix}-file-input`) || (prefix === 'audio' ? document.getElementById('audio-file-input') : null);
      const widget = document.getElementById(`${prefix}-preview-widget`) || (prefix === 'audio' ? document.getElementById('audio-preview-widget') : null);
      const inputMethods = document.getElementById(`${prefix}-input-methods`) || (prefix === 'audio' ? document.getElementById('audio-input-methods') : null);
      const btnRecord = document.getElementById(`btn-${prefix}-record`) || (prefix === 'audio' ? document.getElementById('btn-audio-record') : null);
      const btnPlay = document.getElementById(`btn-${prefix}-play-preview`) || (prefix === 'audio' ? document.getElementById('btn-play-audio-preview') : null);
      const btnRemove = document.getElementById(`btn-${prefix}-remove-audio`) || (prefix === 'audio' ? document.getElementById('btn-remove-audio') : null);
      const audioElement = document.getElementById(`${prefix}-audio-element`) || (prefix === 'audio' ? document.getElementById('html5-audio-element') : null);
      const durationLabel = document.getElementById(`${prefix}-duration-label`) || (prefix === 'audio' ? document.getElementById('audio-duration-label') : null);
      const progressBar = document.getElementById(`${prefix}-progress-bar`) || (prefix === 'audio' ? document.getElementById('audio-progress-bar') : null);
      const progressTrack = widget ? widget.querySelector('.audio-progress-track') : null;
      const fileTitle = document.getElementById(`${prefix}-file-title`) || (prefix === 'audio' ? document.getElementById('audio-file-title') : null);
      const statusTitle = document.getElementById(`${prefix}-record-status-title`) || (prefix === 'audio' ? document.getElementById('record-status-title') : null);
      const statusDesc = document.getElementById(`${prefix}-record-status-desc`) || (prefix === 'audio' ? document.getElementById('record-status-desc') : null);

      if (!fileInput && !btnRecord) return;

      const updateAudioDurationDisplay = (durSec) => {
        if (!this.state.audio) return;
        const formatted = this.formatTime(durSec);
        this.state.audio.durationSec = durSec;
        this.state.audio.duration = formatted;
        
        document.querySelectorAll('.audio-duration-label').forEach(dl => {
          const curStr = audioElement && !audioElement.paused ? this.formatTime(audioElement.currentTime) : '0:00';
          dl.textContent = `${curStr} / ${formatted}`;
        });

        const previewTime = document.getElementById('preview-audio-time');
        if (previewTime) {
          previewTime.textContent = `0:00 / ${formatted}`;
        }
      };

      const handleAudioFile = async (file, knownDurationSec = null) => {
        if (!file) return;
        const url = URL.createObjectURL(file);
        const initialDurStr = knownDurationSec ? this.formatTime(knownDurationSec) : '0:00';
        
        this.state.audio = {
          name: file.name,
          file: file,
          url: url,
          durationSec: knownDurationSec || 0,
          duration: initialDurStr
        };

        // Update all audio widgets in DOM
        document.querySelectorAll('.audio-input-methods').forEach(im => im.style.display = 'none');
        document.querySelectorAll('.audio-preview-widget').forEach(pw => pw.style.display = 'flex');
        document.querySelectorAll('.audio-file-title').forEach(ft => ft.textContent = file.name);
        document.querySelectorAll('.audio-duration-label').forEach(dl => dl.textContent = `0:00 / ${initialDurStr}`);
        document.querySelectorAll('.audio-progress-bar').forEach(pb => pb.style.width = '0%');
        
        if (audioElement) {
          audioElement.src = url;
          audioElement.load();
        }
        this.clearFieldError('pronunciation');

        const durSec = await this.getAudioDuration(file, knownDurationSec);
        if (this.state.audio && this.state.audio.file === file) {
          updateAudioDurationDisplay(durSec);
        }
      };

      if (fileInput) fileInput.addEventListener('change', (e) => handleAudioFile(e.target.files[0]));

      let recordInterval = null;
      let recordStartTime = 0;
      let mediaStream = null;

      const stopRecording = () => {
        if (recordInterval) {
          clearInterval(recordInterval);
          recordInterval = null;
        }
        if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
          this.mediaRecorder.stop();
        }
        if (mediaStream) {
          mediaStream.getTracks().forEach(track => track.stop());
          mediaStream = null;
        }
        if (btnRecord) {
          btnRecord.classList.remove('recording');
        }
        if (statusTitle) statusTitle.textContent = 'Record Voice Note';
        if (statusDesc) statusDesc.textContent = 'Click mic to record pronunciation';
      };

      if (btnRecord) {
        btnRecord.addEventListener('click', async () => {
          if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
            stopRecording();
            return;
          }

          try {
            mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true });
            let mimeType = 'audio/webm';
            if (MediaRecorder.isTypeSupported('audio/webm;codecs=opus')) {
              mimeType = 'audio/webm;codecs=opus';
            } else if (MediaRecorder.isTypeSupported('audio/mp4')) {
              mimeType = 'audio/mp4';
            } else if (MediaRecorder.isTypeSupported('audio/wav')) {
              mimeType = 'audio/wav';
            }

            this.mediaRecorder = new MediaRecorder(mediaStream, mimeType ? { mimeType } : undefined);
            this.audioChunks = [];
            recordStartTime = Date.now();

            this.mediaRecorder.ondataavailable = (e) => {
              if (e.data && e.data.size > 0) this.audioChunks.push(e.data);
            };

            this.mediaRecorder.onstop = () => {
              const totalSec = Math.max(1, (Date.now() - recordStartTime) / 1000);
              const actualMime = this.mediaRecorder.mimeType || 'audio/webm';
              const ext = actualMime.includes('mp4') ? 'm4a' : actualMime.includes('wav') ? 'wav' : 'webm';
              const blob = new Blob(this.audioChunks, { type: actualMime });
              const nameClean = (this.state.name || 'voice').toLowerCase().replace(/[^a-z0-9_-]/g, '_');
              const fakeFile = new File([blob], `pronunciation_${nameClean}.${ext}`, { type: actualMime });
              handleAudioFile(fakeFile, totalSec);
            };

            this.mediaRecorder.start(250);
            btnRecord.classList.add('recording');
            
            if (statusDesc) statusDesc.textContent = 'Click mic to stop recording';

            recordInterval = setInterval(() => {
              const elapsed = (Date.now() - recordStartTime) / 1000;
              if (statusTitle) statusTitle.textContent = `🔴 Recording: ${this.formatTime(elapsed)} (Max 0:30)`;
              if (elapsed >= 30) {
                stopRecording();
              }
            }, 200);

          } catch (e) {
            alert('Microphone access was denied or is not supported. Please upload an MP3/WAV file.');
          }
        });
      }

      if (btnPlay && audioElement) {
        btnPlay.addEventListener('click', () => {
          if (audioElement.paused) {
            audioElement.play().catch(() => {});
            const playIcon = btnPlay.querySelector('.play-state-icon');
            if (playIcon) playIcon.textContent = '⏸';
          } else {
            audioElement.pause();
            const playIcon = btnPlay.querySelector('.play-state-icon');
            if (playIcon) playIcon.textContent = '▶';
          }
        });

        audioElement.addEventListener('timeupdate', () => {
          const cur = audioElement.currentTime;
          const dur = (audioElement.duration && isFinite(audioElement.duration) && audioElement.duration > 0) 
            ? audioElement.duration 
            : (this.state.audio?.durationSec || 0);
          const curStr = this.formatTime(cur);
          const durStr = dur > 0 ? this.formatTime(dur) : (this.state.audio?.duration || '0:00');
          
          document.querySelectorAll('.audio-duration-label').forEach(dl => {
            dl.textContent = `${curStr} / ${durStr}`;
          });
          if (progressBar && dur > 0) {
            progressBar.style.width = `${Math.min(100, (cur / dur) * 100)}%`;
          }
        });

        audioElement.addEventListener('loadedmetadata', () => {
          if (isFinite(audioElement.duration) && audioElement.duration > 0) {
            updateAudioDurationDisplay(audioElement.duration);
          }
        });

        audioElement.addEventListener('ended', () => {
          const playIcon = btnPlay.querySelector('.play-state-icon');
          if (playIcon) playIcon.textContent = '▶';
          if (progressBar) progressBar.style.width = '0%';
          const durStr = this.state.audio?.duration || (audioElement.duration > 0 ? this.formatTime(audioElement.duration) : '0:00');
          document.querySelectorAll('.audio-duration-label').forEach(dl => {
            dl.textContent = `0:00 / ${durStr}`;
          });
        });

        if (progressTrack) {
          progressTrack.addEventListener('click', (e) => {
            const rect = progressTrack.getBoundingClientRect();
            const clickX = e.clientX - rect.left;
            const width = rect.width;
            const dur = (audioElement.duration && isFinite(audioElement.duration) && audioElement.duration > 0)
              ? audioElement.duration
              : (this.state.audio?.durationSec || 0);
            if (dur > 0 && width > 0) {
              const seek = (clickX / width) * dur;
              audioElement.currentTime = seek;
            }
          });
        }
      }

      if (btnRemove) {
        btnRemove.addEventListener('click', () => {
          this.state.audio = null;
          if (audioElement) {
            audioElement.pause();
            audioElement.removeAttribute('src');
          }
          if (fileInput) fileInput.value = '';
          document.querySelectorAll('.audio-progress-bar').forEach(pb => pb.style.width = '0%');
          document.querySelectorAll('.audio-duration-label').forEach(dl => dl.textContent = '0:00 / 0:00');
          document.querySelectorAll('.audio-input-methods').forEach(im => im.style.display = 'grid');
          document.querySelectorAll('.audio-preview-widget').forEach(pw => pw.style.display = 'none');
        });
      }
    }

    /* --------------------------------------------------------------------------
       Bespoke Child Photo Uploader
       -------------------------------------------------------------------------- */
    bindBespokeUploader() {
      const dropzone = document.getElementById('child-photo-dropzone');
      const fileInput = document.getElementById('child-photo-input');
      const replaceInput = document.getElementById('child-photo-replace-input');
      const widget = document.getElementById('child-photo-preview-widget');
      const btnRemove = document.getElementById('btn-remove-child-photo');
      const previewImg = document.getElementById('child-photo-preview-img');
      const btnZoom = document.getElementById('btn-child-photo-zoom');

      const handleChildFile = (file) => {
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.state.childPhoto = {
            name: file.name,
            file: file,
            size: (file.size / (1024 * 1024)).toFixed(1) + ' MB',
            url: e.target.result
          };
          if (dropzone) dropzone.style.display = 'none';
          if (widget) widget.style.display = 'flex';
          if (previewImg) previewImg.src = e.target.result;
          const fnEl = document.getElementById('child-photo-filename');
          const fsEl = document.getElementById('child-photo-filesize');
          if (fnEl) fnEl.textContent = file.name;
          if (fsEl) fsEl.textContent = this.state.childPhoto.size;
          this.clearFieldError('childPhoto');
        };
        reader.readAsDataURL(file);
      };

      if (fileInput) fileInput.addEventListener('change', (e) => handleChildFile(e.target.files[0]));
      if (replaceInput) replaceInput.addEventListener('change', (e) => handleChildFile(e.target.files[0]));
      this.bindDragDrop(dropzone, handleChildFile);

      if (btnZoom) {
        btnZoom.addEventListener('click', () => {
          if (this.state.childPhoto) {
            this.openZoomModal(this.state.childPhoto.url, `Child Portrait: ${this.state.childPhoto.name}`);
          }
        });
      }

      if (btnRemove) {
        btnRemove.addEventListener('click', () => {
          this.state.childPhoto = null;
          if (dropzone) dropzone.style.display = 'block';
          if (widget) widget.style.display = 'none';
        });
      }
    }

    renderPhotoThumbnails(gridEl, counterEl, maxLimit, photoArray, stateKey = 'photos', unitLabel = 'photos') {
      if (!gridEl) return;
      if (counterEl) counterEl.textContent = `${photoArray.length} / ${maxLimit} ${unitLabel}`;

      gridEl.innerHTML = photoArray.map((photo, i) => `
        <div class="thumb-item" data-photo-index="${i}">
          <img src="${photo.url}" alt="${photo.name}" class="thumb-img" />
          <span class="thumb-badge">#${i + 1}</span>
          <button type="button" class="btn-thumb-zoom" data-index="${i}" title="Magnify Image">🔍</button>
          <div class="thumb-actions-bar">
            <label class="btn-thumb-action" title="Replace Photo">
              🔄
              <input type="file" accept="image/*" class="sr-only thumb-replace-input" data-index="${i}" />
            </label>
            <button type="button" class="btn-thumb-action btn-thumb-remove" data-index="${i}" title="Remove photo">🗑️</button>
          </div>
        </div>
      `).join('');

      gridEl.querySelectorAll('.btn-thumb-zoom').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const idx = parseInt(btn.getAttribute('data-index'), 10);
          this.openZoomModal(photoArray[idx].url, `Photo #${idx + 1}: ${photoArray[idx].name}`, idx, photoArray);
        });
      });

      gridEl.querySelectorAll('.thumb-replace-input').forEach(input => {
        input.addEventListener('change', (e) => {
          const idx = parseInt(input.getAttribute('data-index'), 10);
          const file = e.target.files[0];
          if (file) {
            const reader = new FileReader();
            reader.onload = (ev) => {
              photoArray[idx] = {
                name: file.name,
                file: file,
                size: (file.size / (1024 * 1024)).toFixed(1) + ' MB',
                url: ev.target.result
              };
              this.renderPhotoThumbnails(gridEl, counterEl, maxLimit, photoArray, stateKey, unitLabel);
            };
            reader.readAsDataURL(file);
          }
        });
      });

      gridEl.querySelectorAll('.btn-thumb-remove').forEach(btn => {
        btn.addEventListener('click', () => {
          const idx = parseInt(btn.getAttribute('data-index'), 10);
          photoArray.splice(idx, 1);
          this.renderPhotoThumbnails(gridEl, counterEl, maxLimit, photoArray, stateKey, unitLabel);
        });
      });
    }

    bindDragDrop(dropzone, onFileDrop) {
      if (!dropzone) return;
      ['dragenter', 'dragover'].forEach(name => {
        dropzone.addEventListener(name, (e) => {
          e.preventDefault();
          dropzone.classList.add('drag-over');
        });
      });
      ['dragleave', 'drop'].forEach(name => {
        dropzone.addEventListener(name, (e) => {
          e.preventDefault();
          dropzone.classList.remove('drag-over');
        });
      });
      dropzone.addEventListener('drop', (e) => {
        e.preventDefault();
        dropzone.classList.remove('drag-over');
        if (e.dataTransfer && e.dataTransfer.files) onFileDrop(e.dataTransfer.files);
      });
    }

    validate() {
      // Reset all previous error states
      this.root.querySelectorAll('.field-error-text').forEach(el => {
        el.textContent = '';
        el.classList.remove('visible');
      });

      const errors = {};
      if (!this.state.name || !this.state.name.trim()) {
        errors.name = "Please enter recipient's name.";
      }
      if ((this.category === 'noaudionew' || this.category === 'cards') && this.state.photos.length === 0) {
        errors.photos = 'Please upload at least 1 photo for personalization.';
      }
      if ((this.category === 'noaudiofamily' || this.category === 'mealtime') && this.state.soloPhotos.length === 0) {
        errors.soloPhotos = 'Please upload at least 1 photo for personalization.';
      }
      if ((this.category === 'audionew' || this.category === 'audioimage' || this.category === 'audio') && !this.state.audio) {
        errors.pronunciation = 'Please upload or record the pronunciation audio.';
      }
      if (this.category === 'bespoke' && !this.state.childPhoto) {
        errors.childPhoto = 'Please upload a photo of the child.';
      }

      this.state.errors = errors;
      Object.keys(errors).forEach(k => this.showFieldError(k, errors[k]));

      if (Object.keys(errors).length > 0) {
        const activeWrapper = document.getElementById(`fields-${this.category}`) || this.root;
        const firstErr = activeWrapper.querySelector('.field-error-text.visible') || this.root.querySelector('.field-error-text.visible');
        if (firstErr) firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      return true;
    }

    showFieldError(fieldKey, message) {
      const activeWrapper = document.getElementById(`fields-${this.category}`);
      let targetEls = [];

      if (activeWrapper) {
        targetEls = Array.from(activeWrapper.querySelectorAll(
          `#error-${fieldKey}, #error-${this.category}-${fieldKey}, [data-error-for="${fieldKey}"], [data-field-group="${fieldKey}"] .field-error-text`
        ));
      }

      if (!targetEls || targetEls.length === 0) {
        targetEls = Array.from(this.root.querySelectorAll(
          `#error-${fieldKey}, #error-${this.category}-${fieldKey}, [data-error-for="${fieldKey}"], [data-field-group="${fieldKey}"] .field-error-text`
        ));
      }

      targetEls.forEach(el => {
        el.textContent = message;
        el.classList.add('visible');
      });
    }

    clearFieldError(fieldKey) {
      const targetEls = this.root.querySelectorAll(
        `#error-${fieldKey}, [data-error-for="${fieldKey}"], [data-field-group="${fieldKey}"] .field-error-text, [id*="-${fieldKey}"]`
      );
      targetEls.forEach(el => {
        el.textContent = '';
        el.classList.remove('visible');
      });
    }

    /* --------------------------------------------------------------------------
       Live Proof View & Multi-Image Gallery
       -------------------------------------------------------------------------- */
    showSampleProof() {
      this.panelForm.classList.remove('active');
      this.panelSample.classList.add('active');
      this.step1.classList.remove('active');
      this.step1.classList.add('completed');
      this.step2.classList.add('active');

      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.renderSampleCanvas();
      this.renderSampleSpecSheet();
    }

    showFormView() {
      this.panelSample.classList.remove('active');
      this.panelForm.classList.add('active');
      this.step2.classList.remove('active');
      this.step1.classList.remove('completed');
      this.step1.classList.add('active');

      this.root.querySelectorAll('input[name="properties[Personalized Name]"]').forEach(input => { input.value = this.state.name; });
      const notesInput = document.getElementById('input-customer-notes');
      if (notesInput) notesInput.value = this.state.notes;

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    renderSampleCanvas() {
      const viewport = document.getElementById('sample-display-viewport');      
      const toggles = document.getElementById('sample-view-toggles');
      if (!viewport) return;

      // 1. Tag: audionew (Audio Only Proof — No Photos)
      if (this.category === 'audionew') {
        toggles.innerHTML = `<span class="proof-tag">🎙️ Studio Audio Story & Lullaby Proof</span>`;

        viewport.innerHTML = `
          <div class="proof-audio-interactive-stage audionew-stage">
            <div class="proof-vinyl-record" id="preview-vinyl-disc">
              <div class="vinyl-center">
                <strong>${this.state.name || 'Recipient'}'s Story</strong>
                <span>Personalized Audio</span>
              </div>
            </div>

            <div class="preview-audio-player-deck">
              <div class="deck-title-row">
                <span class="audio-badge">🎵 Studio-Recorded Audio</span>
                <strong>Spoken Story for ${this.state.name || 'Recipient'}</strong>
              </div>

              <div class="audio-gender-pill-badge">
                <span>Selected Voice Style: <strong>${this.state.gender}</strong></span>
              </div>

              <div class="preview-player-controls-row">
                <button type="button" class="btn-preview-play-audio" id="btn-preview-play-audio">
                  <span class="play-icon-glyph">▶</span> Play Pronunciation
                </button>
                <div class="preview-waveform-anim" id="preview-waveform-bars">
                  <span></span><span></span><span></span><span></span>
                  <span></span><span></span><span></span><span></span>
                </div>
                <span class="preview-audio-time" id="preview-audio-time">0:00 / ${this.state.audio?.duration || '0:00'}</span>
              </div>

              <audio id="preview-native-audio" src="${this.state.audio?.url || ''}" preload="auto" class="sr-only"></audio>

              <div class="preview-audio-edit-actions">
                <label class="btn-audio-edit-action">
                  📁 Replace Audio File (MP3/WAV)
                  <input type="file" id="preview-audio-replace-input" accept="audio/*" class="sr-only" />
                </label>
                <button type="button" class="btn-audio-edit-action" id="btn-preview-rerecord-audio">
                  🎤 Re-record Voice Note
                </button>
              </div>

              <div class="audio-proof-filename">
                <span>Pronunciation File: <strong>${this.state.audio?.name || 'pronunciation.mp3'}</strong></span>
              </div>
            </div>
          </div>
        `;

        this.bindSampleAudioPlayerControls(viewport);

      // 2. Tag: noaudionew & Legacy Cards (Image Only Proof — Max 10 Photos)
      } else if (this.category === 'noaudionew' || this.category === 'cards') {
        const photoCount = this.state.photos.length;
        toggles.innerHTML = `<span class="proof-count-status">📸 Showing all <strong>${photoCount}</strong> Personalized Proofs</span>`;

        viewport.innerHTML = `
          <div class="multi-card-preview-container">
            <div class="featured-card-spotlight">
              <div class="proof-card-3d card-featured" id="featured-proof-card">
                <div class="card-foil-frame">
                  <div class="card-hero-tag">
                    <span>Photo #${this.activePreviewCardIndex + 1} of ${photoCount}</span>
                    <span class="card-theme-tag">${this.state.gender} Style</span>
                  </div>
                  <h2 class="card-title">PERSONALIZED MASTERPIECE</h2>
                  
                  <div class="card-photo-box" id="featured-card-photo-box" title="Click to zoom in">
                    <img src="${this.state.photos[this.activePreviewCardIndex]?.url || ''}" alt="${this.state.name}" class="card-img" />
                    <button type="button" class="btn-card-magnifier" id="btn-magnify-featured" title="Zoom In">🔍 Zoom</button>
                  </div>

                  <div class="card-name-badge" id="preview-active-card-name">${this.state.name || 'Recipient Name'}</div>
                  <p class="card-footer-msg">Handcrafted for ${this.state.name || 'Recipient'}</p>
                </div>
              </div>

              <div class="featured-card-actions">
                <button type="button" class="btn-preview-action btn-zoom-action" id="btn-zoom-featured-bottom">🔍 Magnify Fullscreen</button>
                <label class="btn-preview-action" title="Replace this specific photo">
                  🔄 Replace Image #${this.activePreviewCardIndex + 1}
                  <input type="file" accept="image/*" class="sr-only" id="btn-preview-replace-current" />
                </label>
                <button type="button" class="btn-preview-action btn-danger" id="btn-preview-delete-current" title="Remove photo">🗑️ Remove</button>
              </div>
            </div>

            <div class="preview-all-images-strip">
              <div class="gallery-strip-header">
                <strong>All Uploaded Photos (${photoCount}/10):</strong>
                <span>Click thumbnail to spotlight or 🔍 to zoom</span>
              </div>

              <div class="preview-cards-grid">
                ${this.state.photos.map((photo, idx) => `
                  <div class="preview-card-item ${idx === this.activePreviewCardIndex ? 'active-card-thumb' : ''}" data-card-index="${idx}">
                    <div class="preview-thumb-wrap">
                      <img src="${photo.url}" alt="${photo.name}" />
                      <span class="preview-card-number">#${idx + 1}</span>
                      <button type="button" class="btn-thumb-zoom-overlay" data-index="${idx}" title="Magnify">🔍</button>
                    </div>
                    <div class="preview-thumb-details">
                      <span class="thumb-filename" title="${photo.name}">${photo.name}</span>
                    </div>
                    <div class="preview-thumb-actions">
                      <label class="btn-thumb-edit" title="Replace">
                        🔄
                        <input type="file" accept="image/*" class="sr-only preview-item-replace-input" data-index="${idx}" />
                      </label>
                      <button type="button" class="btn-thumb-edit btn-thumb-delete" data-index="${idx}" title="Remove">🗑️</button>
                    </div>
                  </div>
                `).join('')}

                ${photoCount < 10 ? `
                  <label class="preview-card-add-more" title="Add More Photos">
                    <span class="add-icon">➕</span>
                    <span>Add Photo (${photoCount + 1}/10)</span>
                    <input type="file" accept="image/*" multiple class="sr-only" id="preview-add-more-photos-input" />
                  </label>
                ` : ''}
              </div>
            </div>
          </div>
        `;

        this.bindCardProofInteractions(viewport);

      // 3. Tag: noaudiofamily & Legacy Mealtime (10 Kid Solo + 5 Family Photos)
      } else if (this.category === 'noaudiofamily' || this.category === 'mealtime') {
        const soloCount = this.state.soloPhotos.length;
        const familyCount = this.state.familyPhotos.length;
        const activeSoloPhoto = this.state.soloPhotos[this.activeSoloPhotoIndex] || this.state.soloPhotos[0];

        toggles.innerHTML = `<span class="proof-count-status">📸 <strong>${soloCount}</strong> Kid Photo(s) • <strong>${familyCount}</strong> Family Photo(s)</span>`;

        viewport.innerHTML = `
          <div class="multi-card-preview-container mealtime-proof-container">
            <div class="featured-card-spotlight">
              <div class="proof-card-3d card-featured mealtime-plate-mockup" id="featured-proof-card">
                <div class="card-foil-frame">
                  <div class="card-hero-tag">
                    <span>Kid Center Medallion (${this.activeSoloPhotoIndex + 1}/${Math.max(1, soloCount)})</span>
                    <span class="card-theme-tag">${this.state.gender} Style</span>
                  </div>
                  <h2 class="card-title">${this.state.name ? `${this.state.name.toUpperCase()}'S PERSONALIZED SET` : 'PERSONALIZED FAMILY SET'}</h2>
                  
                  <div class="card-photo-box" id="featured-card-photo-box" title="Click to zoom in">
                    <img src="${activeSoloPhoto?.url || ''}" alt="${this.state.name}" class="card-img mealtime-plate-img" />
                    <button type="button" class="btn-card-magnifier" id="btn-magnify-featured" title="Zoom In">🔍 Zoom</button>
                  </div>

                  <div class="card-name-badge" id="preview-active-card-name">${this.state.name || "Recipient's Name"}</div>
                  <p class="card-footer-msg">Cherished Custom Family Heirloom</p>
                </div>
              </div>

              <div class="featured-card-actions">
                <button type="button" class="btn-preview-action btn-zoom-action" id="btn-zoom-solo-bottom">🔍 Magnify Kid Photo</button>
                <label class="btn-preview-action" title="Replace this specific solo photo">
                  🔄 Replace Kid Photo #${this.activeSoloPhotoIndex + 1}
                  <input type="file" accept="image/*" class="sr-only" id="btn-preview-replace-solo" />
                </label>
              </div>
            </div>

            <!-- All Kid Photos Gallery Strip -->
            <div class="preview-all-images-strip">
              <div class="gallery-strip-header">
                <strong>👶 Uploaded Kid Photos (${soloCount}/10):</strong>
                <span>Click to spotlight on hero design</span>
              </div>

              <div class="preview-cards-grid">
                ${this.state.soloPhotos.map((photo, idx) => `
                  <div class="preview-card-item ${idx === this.activeSoloPhotoIndex ? 'active-card-thumb' : ''}" data-solo-index="${idx}">
                    <div class="preview-thumb-wrap">
                      <img src="${photo.url}" alt="${photo.name}" />
                      <span class="preview-card-number">#${idx + 1}</span>
                      <button type="button" class="btn-thumb-zoom-overlay" data-solo-idx="${idx}" title="Magnify">🔍</button>
                    </div>
                    <div class="preview-thumb-details">
                      <span class="thumb-filename" title="${photo.name}">${photo.name}</span>
                    </div>
                    <div class="preview-thumb-actions">
                      <label class="btn-thumb-edit" title="Replace">
                        🔄
                        <input type="file" accept="image/*" class="sr-only preview-solo-replace-input" data-solo-idx="${idx}" />
                      </label>
                      <button type="button" class="btn-thumb-edit btn-thumb-delete-solo" data-solo-idx="${idx}" title="Remove">🗑️</button>
                    </div>
                  </div>
                `).join('')}

                ${soloCount < 10 ? `
                  <label class="preview-card-add-more" title="Add More Kid Photos">
                    <span class="add-icon">➕</span>
                    <span>Add Kid Photo (${soloCount + 1}/10)</span>
                    <input type="file" accept="image/*" multiple class="sr-only" id="preview-add-more-solo-input" />
                  </label>
                ` : ''}
              </div>
            </div>

            <!-- Family Photos Strip -->
            <div class="preview-all-images-strip family-strip-section">
              <div class="gallery-strip-header">
                <strong>👨‍👩‍👧 Family Photos (${familyCount}/5):</strong>
                <span>Companion personalized items</span>
              </div>

              <div class="preview-cards-grid">
                ${this.state.familyPhotos.map((photo, idx) => `
                  <div class="preview-card-item ${idx === this.activeFamilyPhotoIndex ? 'active-family-thumb' : ''}" data-family-index="${idx}">
                    <div class="preview-thumb-wrap">
                      <img src="${photo.url}" alt="${photo.name}" />
                      <span class="preview-card-number">Fam #${idx + 1}</span>
                      <button type="button" class="btn-thumb-zoom-overlay" data-family-idx="${idx}" title="Magnify">🔍</button>
                    </div>
                    <div class="preview-thumb-details">
                      <span class="thumb-filename" title="${photo.name}">${photo.name}</span>
                    </div>
                    <div class="preview-thumb-actions">
                      <label class="btn-thumb-edit" title="Replace">
                        🔄
                        <input type="file" accept="image/*" class="sr-only preview-family-replace-input" data-family-idx="${idx}" />
                      </label>
                      <button type="button" class="btn-thumb-edit btn-thumb-delete-family" data-family-idx="${idx}" title="Remove">🗑️</button>
                    </div>
                  </div>
                `).join('')}

                ${familyCount < 5 ? `
                  <label class="preview-card-add-more" title="Add Family Photos">
                    <span class="add-icon">➕</span>
                    <span>Add Family Photo (${familyCount + 1}/5)</span>
                    <input type="file" accept="image/*" multiple class="sr-only" id="preview-add-more-family-input" />
                  </label>
                ` : ''}
              </div>
            </div>
          </div>
        `;

        this.bindMealtimeProofInteractions(viewport);

      // 4. Tag: audioimage & Legacy Audio (Spoken Audio + Up to 5 Photos)
      } else if (this.category === 'audioimage' || this.category === 'audio') {
        const audioPhotoCount = this.state.photos.length;
        toggles.innerHTML = `<span class="proof-tag">🎧 Interactive Audio Proof & Cover Artwork</span>`;

        viewport.innerHTML = `
          <div class="proof-audio-interactive-stage">
            <div class="proof-vinyl-record" id="preview-vinyl-disc">
              <div class="vinyl-center">
                <strong>${this.state.name || 'Recipient'}'s Tale</strong>
                <span>Personalized Audio</span>
              </div>
            </div>

            <div class="preview-audio-player-deck">
              <div class="deck-title-row">
                <span class="audio-badge">🎵 Spoken Name Proof</span>
                <strong>Story for ${this.state.name || 'Recipient'}</strong>
              </div>

              <div class="audio-gender-pill-badge">
                <span>Selected Voice Style: <strong>${this.state.gender}</strong></span>
              </div>

              <div class="preview-player-controls-row">
                <button type="button" class="btn-preview-play-audio" id="btn-preview-play-audio">
                  <span class="play-icon-glyph">▶</span> Play Audio
                </button>
                <div class="preview-waveform-anim" id="preview-waveform-bars">
                  <span></span><span></span><span></span><span></span>
                  <span></span><span></span><span></span><span></span>
                </div>
                <span class="preview-audio-time" id="preview-audio-time">0:00 / ${this.state.audio?.duration || '0:00'}</span>
              </div>

              <audio id="preview-native-audio" src="${this.state.audio?.url || ''}" preload="auto" class="sr-only"></audio>

              <div class="preview-audio-edit-actions">
                <label class="btn-audio-edit-action">
                  📁 Replace Audio File (MP3/WAV)
                  <input type="file" id="preview-audio-replace-input" accept="audio/*" class="sr-only" />
                </label>
                <button type="button" class="btn-audio-edit-action" id="btn-preview-rerecord-audio">
                  🎤 Re-record Voice Note
                </button>
              </div>

              <div class="audio-proof-filename">
                <span>Attached: <strong>${this.state.audio?.name || 'pronunciation.mp3'}</strong></span>
              </div>
            </div>

            ${audioPhotoCount > 0 ? `
              <div class="preview-all-images-strip audio-photos-strip">
                <div class="gallery-strip-header">
                  <strong>📸 Attached Photos (${audioPhotoCount}/5):</strong>
                  <span>Personalized digital keepsake artwork</span>
                </div>

                <div class="preview-cards-grid">
                  ${this.state.photos.map((photo, idx) => `
                    <div class="preview-card-item" data-audio-photo-index="${idx}">
                      <div class="preview-thumb-wrap">
                        <img src="${photo.url}" alt="${photo.name}" />
                        <span class="preview-card-number">#${idx + 1}</span>
                        <button type="button" class="btn-thumb-zoom-overlay" data-audio-idx="${idx}" title="Magnify">🔍</button>
                      </div>
                      <div class="preview-thumb-details">
                        <span class="thumb-filename" title="${photo.name}">${photo.name}</span>
                      </div>
                      <div class="preview-thumb-actions">
                        <label class="btn-thumb-edit" title="Replace">
                          🔄
                          <input type="file" accept="image/*" class="sr-only preview-audio-photo-replace-input" data-audio-idx="${idx}" />
                        </label>
                        <button type="button" class="btn-thumb-edit btn-thumb-delete-audio-photo" data-audio-idx="${idx}" title="Remove">🗑️</button>
                      </div>
                    </div>
                  `).join('')}

                  ${audioPhotoCount < 5 ? `
                    <label class="preview-card-add-more" title="Add More Photos">
                      <span class="add-icon">➕</span>
                      <span>Add Photo (${audioPhotoCount + 1}/5)</span>
                      <input type="file" accept="image/*" multiple class="sr-only" id="preview-add-more-audio-photos-input" />
                    </label>
                  ` : ''}
                </div>
              </div>
            ` : ''}
          </div>
        `;

        this.bindSampleAudioPlayerControls(viewport);

      // 5. Bespoke Fallback
      } else if (this.category === 'bespoke') {
        toggles.innerHTML = `<span class="proof-tag">📖 Hardcover Heirloom Proof</span>`;
        const childImg = this.state.childPhoto?.url || 'https://images.unsplash.com/photo-1545558014-8692077e9b5c?auto=format&fit=crop&w=800&q=80';

        viewport.innerHTML = `
          <div class="proof-storybook-stage">
            <div class="proof-storybook-cover">
              <div class="book-foil-title">THE WONDERFUL ADVENTURES OF</div>
              <div class="book-child-title">${this.state.name || 'Noah'}</div>
              <div class="book-portrait-circle" id="bespoke-book-portrait" title="Click to zoom in">
                <img src="${childImg}" alt="${this.state.name}" />
                <button type="button" class="btn-card-magnifier" id="btn-magnify-child" title="Zoom In">🔍 Zoom</button>
              </div>
              <div class="book-edition-seal">★ 100-YEAR HEIRLOOM EDITION ★</div>
            </div>

            <div class="preview-bespoke-actions">
              <button type="button" class="btn-preview-action btn-zoom-action" id="btn-zoom-child-bottom">🔍 Magnify Child Portrait</button>
              <label class="btn-preview-action">
                🔄 Replace Child Photo
                <input type="file" id="preview-child-replace-input" accept="image/*" class="sr-only" />
              </label>
            </div>
          </div>
        `;

        const triggerChildZoom = () => {
          if (this.state.childPhoto) this.openZoomModal(this.state.childPhoto.url, `Child Portrait: ${this.state.childPhoto.name}`);
        };

        document.getElementById('btn-magnify-child')?.addEventListener('click', triggerChildZoom);
        document.getElementById('btn-zoom-child-bottom')?.addEventListener('click', triggerChildZoom);

        const childReplaceInput = document.getElementById('preview-child-replace-input');
        if (childReplaceInput) {
          childReplaceInput.addEventListener('change', (e) => {
            const file = e.target.files[0];
            if (file) {
              const reader = new FileReader();
              reader.onload = (ev) => {
                this.state.childPhoto = {
                  name: file.name,
                  file: file,
                  size: (file.size / (1024 * 1024)).toFixed(1) + ' MB',
                  url: ev.target.result
                };
                this.renderSampleCanvas();
                this.renderSampleSpecSheet();
              };
              reader.readAsDataURL(file);
            }
          });
        }
      }
    }

    /* --------------------------------------------------------------------------
       Sub-Renderer Interactive Binders
       -------------------------------------------------------------------------- */
    bindSampleAudioPlayerControls(viewport) {
      const btnPlay = document.getElementById('btn-preview-play-audio');
      const audioEl = document.getElementById('preview-native-audio');
      const waveBars = document.getElementById('preview-waveform-bars');
      const vinylDisc = document.getElementById('preview-vinyl-disc');
      const timeLabel = document.getElementById('preview-audio-time');

      if (btnPlay && audioEl) {
        btnPlay.addEventListener('click', () => {
          if (audioEl.paused) {
            audioEl.play().catch(() => {});
            btnPlay.innerHTML = '<span class="play-icon-glyph">⏸</span> Pause Audio';
            if (waveBars) waveBars.classList.add('playing');
            if (vinylDisc) vinylDisc.classList.add('spinning');
          } else {
            audioEl.pause();
            btnPlay.innerHTML = '<span class="play-icon-glyph">▶</span> Play Audio';
            if (waveBars) waveBars.classList.remove('playing');
            if (vinylDisc) vinylDisc.classList.remove('spinning');
          }
        });

        audioEl.addEventListener('timeupdate', () => {
          const cur = audioEl.currentTime;
          const dur = (audioEl.duration && isFinite(audioEl.duration) && audioEl.duration > 0)
            ? audioEl.duration
            : (this.state.audio?.durationSec || 0);
          const curStr = this.formatTime(cur);
          const durStr = dur > 0 ? this.formatTime(dur) : (this.state.audio?.duration || '0:00');
          if (timeLabel) timeLabel.textContent = `${curStr} / ${durStr}`;
        });

        audioEl.addEventListener('loadedmetadata', () => {
          if (isFinite(audioEl.duration) && audioEl.duration > 0) {
            const dur = audioEl.duration;
            if (this.state.audio) {
              this.state.audio.durationSec = dur;
              this.state.audio.duration = this.formatTime(dur);
            }
            if (timeLabel) timeLabel.textContent = `0:00 / ${this.formatTime(dur)}`;
          }
        });

        audioEl.addEventListener('ended', () => {
          btnPlay.innerHTML = '<span class="play-icon-glyph">▶</span> Play Audio';
          if (waveBars) waveBars.classList.remove('playing');
          if (vinylDisc) vinylDisc.classList.remove('spinning');
          const durStr = this.state.audio?.duration || (audioEl.duration > 0 ? this.formatTime(audioEl.duration) : '0:00');
          if (timeLabel) timeLabel.textContent = `0:00 / ${durStr}`;
        });
      }

      const replaceAudioInput = document.getElementById('preview-audio-replace-input');
      if (replaceAudioInput) {
        replaceAudioInput.addEventListener('change', async (e) => {
          const file = e.target.files[0];
          if (file) {
            const dur = await this.getAudioDuration(file);
            this.state.audio = {
              name: file.name,
              file: file,
              url: URL.createObjectURL(file),
              durationSec: dur,
              duration: this.formatTime(dur)
            };
            this.renderSampleCanvas();
            this.renderSampleSpecSheet();

            document.querySelectorAll('.audio-file-title').forEach(ft => ft.textContent = file.name);
            document.querySelectorAll('.audio-duration-label').forEach(dl => dl.textContent = `0:00 / ${this.state.audio.duration}`);
          }
        });
      }

      const btnReRecord = document.getElementById('btn-preview-rerecord-audio');
      let previewStream = null;
      let previewRecorder = null;
      let previewInterval = null;
      let previewStartTime = 0;

      if (btnReRecord) {
        btnReRecord.addEventListener('click', async () => {
          if (previewRecorder && previewRecorder.state === 'recording') {
            if (previewInterval) clearInterval(previewInterval);
            previewRecorder.stop();
            if (previewStream) previewStream.getTracks().forEach(t => t.stop());
            btnReRecord.textContent = '🎤 Re-record Voice Note';
            btnReRecord.classList.remove('recording');
            return;
          }

          try {
            previewStream = await navigator.mediaDevices.getUserMedia({ audio: true });
            let mimeType = 'audio/webm';
            if (MediaRecorder.isTypeSupported('audio/webm;codecs=opus')) mimeType = 'audio/webm;codecs=opus';
            else if (MediaRecorder.isTypeSupported('audio/mp4')) mimeType = 'audio/mp4';
            else if (MediaRecorder.isTypeSupported('audio/wav')) mimeType = 'audio/wav';

            previewRecorder = new MediaRecorder(previewStream, mimeType ? { mimeType } : undefined);
            const chunks = [];
            previewStartTime = Date.now();

            previewRecorder.ondataavailable = e => {
              if (e.data && e.data.size > 0) chunks.push(e.data);
            };

            previewRecorder.onstop = () => {
              const totalSec = Math.max(1, (Date.now() - previewStartTime) / 1000);
              const actualMime = previewRecorder.mimeType || 'audio/webm';
              const ext = actualMime.includes('mp4') ? 'm4a' : actualMime.includes('wav') ? 'wav' : 'webm';
              const blob = new Blob(chunks, { type: actualMime });
              const nameClean = (this.state.name || 'voice').toLowerCase().replace(/[^a-z0-9_-]/g, '_');
              const fakeFile = new File([blob], `pronunciation_${nameClean}.${ext}`, { type: actualMime });
              
              this.state.audio = {
                name: fakeFile.name,
                file: fakeFile,
                url: URL.createObjectURL(fakeFile),
                durationSec: totalSec,
                duration: this.formatTime(totalSec)
              };
              this.renderSampleCanvas();
              this.renderSampleSpecSheet();

              document.querySelectorAll('.audio-file-title').forEach(ft => ft.textContent = fakeFile.name);
              document.querySelectorAll('.audio-duration-label').forEach(dl => dl.textContent = `0:00 / ${this.state.audio.duration}`);
            };

            previewRecorder.start(250);
            btnReRecord.classList.add('recording');
            btnReRecord.textContent = '🔴 Recording: 0:00 (Click to Stop)';

            previewInterval = setInterval(() => {
              const elapsed = (Date.now() - previewStartTime) / 1000;
              btnReRecord.textContent = `🔴 Recording: ${this.formatTime(elapsed)} (Click to Stop)`;
              if (elapsed >= 30) {
                if (previewInterval) clearInterval(previewInterval);
                if (previewRecorder.state === 'recording') previewRecorder.stop();
                if (previewStream) previewStream.getTracks().forEach(t => t.stop());
                btnReRecord.textContent = '🎤 Re-record Voice Note';
                btnReRecord.classList.remove('recording');
              }
            }, 200);

          } catch (err) {
            alert('Microphone access was denied or is not supported. Please upload an MP3/WAV file.');
          }
        });
      }

      viewport.querySelectorAll('[data-audio-idx]').forEach(el => {
        if (el.classList.contains('btn-thumb-zoom-overlay')) {
          el.addEventListener('click', (e) => {
            e.stopPropagation();
            const idx = parseInt(el.getAttribute('data-audio-idx'), 10);
            this.openZoomModal(this.state.photos[idx].url, `Photo #${idx + 1}: ${this.state.photos[idx].name}`, idx, this.state.photos);
          });
        }
      });

      viewport.querySelectorAll('.preview-audio-photo-replace-input').forEach(input => {
        input.addEventListener('change', (e) => {
          const idx = parseInt(input.getAttribute('data-audio-idx'), 10);
          const file = e.target.files[0];
          if (file) {
            const reader = new FileReader();
            reader.onload = (ev) => {
              this.state.photos[idx] = {
                name: file.name,
                file: file,
                size: (file.size / (1024 * 1024)).toFixed(1) + ' MB',
                url: ev.target.result
              };
              this.renderSampleCanvas();
              this.renderSampleSpecSheet();
            };
            reader.readAsDataURL(file);
          }
        });
      });

      viewport.querySelectorAll('.btn-thumb-delete-audio-photo').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const idx = parseInt(btn.getAttribute('data-audio-idx'), 10);
          this.state.photos.splice(idx, 1);
          this.renderSampleCanvas();
          this.renderSampleSpecSheet();
        });
      });

      const addMoreAudioPhotosInput = document.getElementById('preview-add-more-audio-photos-input');
      if (addMoreAudioPhotosInput) {
        addMoreAudioPhotosInput.addEventListener('change', (e) => {
          Array.from(e.target.files).forEach(file => {
            if (this.state.photos.length < 5) {
              const reader = new FileReader();
              reader.onload = (ev) => {
                this.state.photos.push({
                  name: file.name,
                  file: file,
                  size: (file.size / (1024 * 1024)).toFixed(1) + ' MB',
                  url: ev.target.result
                });
                this.renderSampleCanvas();
                this.renderSampleSpecSheet();
              };
              reader.readAsDataURL(file);
            }
          });
        });
      }
    }

    bindCardProofInteractions(viewport) {
      const triggerFeaturedZoom = () => {
        const currentPhoto = this.state.photos[this.activePreviewCardIndex];
        if (currentPhoto) this.openZoomModal(currentPhoto.url, `Photo #${this.activePreviewCardIndex + 1}: ${currentPhoto.name}`, this.activePreviewCardIndex, this.state.photos);
      };

      document.getElementById('btn-magnify-featured')?.addEventListener('click', triggerFeaturedZoom);
      document.getElementById('btn-zoom-featured-bottom')?.addEventListener('click', triggerFeaturedZoom);

      viewport.querySelectorAll('.btn-thumb-zoom-overlay').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const idx = parseInt(btn.getAttribute('data-index'), 10);
          this.openZoomModal(this.state.photos[idx].url, `Photo #${idx + 1}: ${this.state.photos[idx].name}`, idx, this.state.photos);
        });
      });

      viewport.querySelectorAll('.preview-card-item').forEach(item => {
        item.addEventListener('click', (e) => {
          if (e.target.closest('.preview-thumb-actions') || e.target.closest('.btn-thumb-zoom-overlay')) return;
          this.activePreviewCardIndex = parseInt(item.getAttribute('data-card-index'), 10);
          this.renderSampleCanvas();
        });
      });

      const btnReplaceCurrent = document.getElementById('btn-preview-replace-current');
      if (btnReplaceCurrent) {
        btnReplaceCurrent.addEventListener('change', (e) => {
          const file = e.target.files[0];
          if (file) {
            const reader = new FileReader();
            reader.onload = (ev) => {
              this.state.photos[this.activePreviewCardIndex] = {
                name: file.name,
                file: file,
                size: (file.size / (1024 * 1024)).toFixed(1) + ' MB',
                url: ev.target.result
              };
              this.renderSampleCanvas();
              this.renderSampleSpecSheet();
            };
            reader.readAsDataURL(file);
          }
        });
      }

      const btnDeleteCurrent = document.getElementById('btn-preview-delete-current');
      if (btnDeleteCurrent) {
        btnDeleteCurrent.addEventListener('click', () => {
          if (this.state.photos.length <= 1) {
            alert('You must have at least 1 photo.');
            return;
          }
          this.state.photos.splice(this.activePreviewCardIndex, 1);
          if (this.activePreviewCardIndex >= this.state.photos.length) {
            this.activePreviewCardIndex = Math.max(0, this.state.photos.length - 1);
          }
          this.renderSampleCanvas();
          this.renderSampleSpecSheet();
        });
      }

      viewport.querySelectorAll('.preview-item-replace-input').forEach(input => {
        input.addEventListener('change', (e) => {
          const idx = parseInt(input.getAttribute('data-index'), 10);
          const file = e.target.files[0];
          if (file) {
            const reader = new FileReader();
            reader.onload = (ev) => {
              this.state.photos[idx] = {
                name: file.name,
                file: file,
                size: (file.size / (1024 * 1024)).toFixed(1) + ' MB',
                url: ev.target.result
              };
              this.renderSampleCanvas();
              this.renderSampleSpecSheet();
            };
            reader.readAsDataURL(file);
          }
        });
      });

      viewport.querySelectorAll('.btn-thumb-delete').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          if (this.state.photos.length <= 1) {
            alert('You must have at least 1 photo.');
            return;
          }
          const idx = parseInt(btn.getAttribute('data-index'), 10);
          this.state.photos.splice(idx, 1);
          if (this.activePreviewCardIndex >= this.state.photos.length) {
            this.activePreviewCardIndex = Math.max(0, this.state.photos.length - 1);
          }
          this.renderSampleCanvas();
          this.renderSampleSpecSheet();
        });
      });

      const addMoreInput = document.getElementById('preview-add-more-photos-input');
      if (addMoreInput) {
        addMoreInput.addEventListener('change', (e) => {
          Array.from(e.target.files).forEach(file => {
            if (this.state.photos.length < 10) {
              const reader = new FileReader();
              reader.onload = (ev) => {
                this.state.photos.push({
                  name: file.name,
                  file: file,
                  size: (file.size / (1024 * 1024)).toFixed(1) + ' MB',
                  url: ev.target.result
                });
                this.renderSampleCanvas();
                this.renderSampleSpecSheet();
              };
              reader.readAsDataURL(file);
            }
          });
        });
      }
    }

    bindMealtimeProofInteractions(viewport) {
      const triggerSoloZoom = () => {
        const currentSolo = this.state.soloPhotos[this.activeSoloPhotoIndex];
        if (currentSolo) this.openZoomModal(currentSolo.url, `Kid Photo #${this.activeSoloPhotoIndex + 1}: ${currentSolo.name}`, this.activeSoloPhotoIndex, this.state.soloPhotos);
      };

      document.getElementById('btn-magnify-featured')?.addEventListener('click', triggerSoloZoom);
      document.getElementById('btn-zoom-solo-bottom')?.addEventListener('click', triggerSoloZoom);

      viewport.querySelectorAll('[data-solo-idx]').forEach(el => {
        if (el.classList.contains('btn-thumb-zoom-overlay')) {
          el.addEventListener('click', (e) => {
            e.stopPropagation();
            const idx = parseInt(el.getAttribute('data-solo-idx'), 10);
            this.openZoomModal(this.state.soloPhotos[idx].url, `Kid Photo #${idx + 1}: ${this.state.soloPhotos[idx].name}`, idx, this.state.soloPhotos);
          });
        }
      });

      viewport.querySelectorAll('[data-family-idx]').forEach(el => {
        if (el.classList.contains('btn-thumb-zoom-overlay')) {
          el.addEventListener('click', (e) => {
            e.stopPropagation();
            const idx = parseInt(el.getAttribute('data-family-idx'), 10);
            this.openZoomModal(this.state.familyPhotos[idx].url, `Family Photo #${idx + 1}: ${this.state.familyPhotos[idx].name}`, idx, this.state.familyPhotos);
          });
        }
      });

      viewport.querySelectorAll('.preview-card-item[data-solo-index]').forEach(item => {
        item.addEventListener('click', (e) => {
          if (e.target.closest('.preview-thumb-actions') || e.target.closest('.btn-thumb-zoom-overlay')) return;
          this.activeSoloPhotoIndex = parseInt(item.getAttribute('data-solo-index'), 10);
          this.renderSampleCanvas();
        });
      });

      const btnReplaceSolo = document.getElementById('btn-preview-replace-solo');
      if (btnReplaceSolo) {
        btnReplaceSolo.addEventListener('change', (e) => {
          const file = e.target.files[0];
          if (file) {
            const reader = new FileReader();
            reader.onload = (ev) => {
              this.state.soloPhotos[this.activeSoloPhotoIndex] = {
                name: file.name,
                file: file,
                size: (file.size / (1024 * 1024)).toFixed(1) + ' MB',
                url: ev.target.result
              };
              this.renderSampleCanvas();
              this.renderSampleSpecSheet();
            };
            reader.readAsDataURL(file);
          }
        });
      }

      viewport.querySelectorAll('.preview-solo-replace-input').forEach(input => {
        input.addEventListener('change', (e) => {
          const idx = parseInt(input.getAttribute('data-solo-idx'), 10);
          const file = e.target.files[0];
          if (file) {
            const reader = new FileReader();
            reader.onload = (ev) => {
              this.state.soloPhotos[idx] = {
                name: file.name,
                file: file,
                size: (file.size / (1024 * 1024)).toFixed(1) + ' MB',
                url: ev.target.result
              };
              this.renderSampleCanvas();
              this.renderSampleSpecSheet();
            };
            reader.readAsDataURL(file);
          }
        });
      });

      viewport.querySelectorAll('.btn-thumb-delete-solo').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          if (this.state.soloPhotos.length <= 1) {
            alert('You must have at least 1 kid photo.');
            return;
          }
          const idx = parseInt(btn.getAttribute('data-solo-idx'), 10);
          this.state.soloPhotos.splice(idx, 1);
          if (this.activeSoloPhotoIndex >= this.state.soloPhotos.length) {
            this.activeSoloPhotoIndex = Math.max(0, this.state.soloPhotos.length - 1);
          }
          this.renderSampleCanvas();
          this.renderSampleSpecSheet();
        });
      });

      const addMoreSoloInput = document.getElementById('preview-add-more-solo-input');
      if (addMoreSoloInput) {
        addMoreSoloInput.addEventListener('change', (e) => {
          Array.from(e.target.files).forEach(file => {
            if (this.state.soloPhotos.length < 10) {
              const reader = new FileReader();
              reader.onload = (ev) => {
                this.state.soloPhotos.push({
                  name: file.name,
                  file: file,
                  size: (file.size / (1024 * 1024)).toFixed(1) + ' MB',
                  url: ev.target.result
                });
                this.renderSampleCanvas();
                this.renderSampleSpecSheet();
              };
              reader.readAsDataURL(file);
            }
          });
        });
      }

      viewport.querySelectorAll('.preview-family-replace-input').forEach(input => {
        input.addEventListener('change', (e) => {
          const idx = parseInt(input.getAttribute('data-family-idx'), 10);
          const file = e.target.files[0];
          if (file) {
            const reader = new FileReader();
            reader.onload = (ev) => {
              this.state.familyPhotos[idx] = {
                name: file.name,
                file: file,
                size: (file.size / (1024 * 1024)).toFixed(1) + ' MB',
                url: ev.target.result
              };
              this.renderSampleCanvas();
              this.renderSampleSpecSheet();
            };
            reader.readAsDataURL(file);
          }
        });
      });

      viewport.querySelectorAll('.btn-thumb-delete-family').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const idx = parseInt(btn.getAttribute('data-family-idx'), 10);
          this.state.familyPhotos.splice(idx, 1);
          this.renderSampleCanvas();
          this.renderSampleSpecSheet();
        });
      });

      const addMoreFamilyInput = document.getElementById('preview-add-more-family-input');
      if (addMoreFamilyInput) {
        addMoreFamilyInput.addEventListener('change', (e) => {
          Array.from(e.target.files).forEach(file => {
            if (this.state.familyPhotos.length < 5) {
              const reader = new FileReader();
              reader.onload = (ev) => {
                this.state.familyPhotos.push({
                  name: file.name,
                  file: file,
                  size: (file.size / (1024 * 1024)).toFixed(1) + ' MB',
                  url: ev.target.result
                });
                this.renderSampleCanvas();
                this.renderSampleSpecSheet();
              };
              reader.readAsDataURL(file);
            }
          });
        });
      }
    }

    renderSampleSpecSheet() {
      const table = document.getElementById('spec-attributes-table');
      if (!table) return;

      const hasSoloPhotos = (this.category === 'noaudiofamily' || this.category === 'mealtime');
      const hasRegularPhotos = (this.category === 'noaudionew' || this.category === 'audioimage' || this.category === 'cards' || this.category === 'audio') && this.state.photos.length > 0;

      table.innerHTML = `
        <div class="spec-edit-row">
          <label class="spec-edit-label" for="preview-inline-name"><span><span class="spec-edit-label_icon">✏️</span> Recipient's Name:</span></label>
          <input type="text" id="preview-inline-name" class="spec-inline-input" value="${this.escapeHtml(this.state.name)}" placeholder="Recipient's Name" maxlength="30" />
        </div>

        <div class="spec-edit-row">
          <span class="spec-edit-label"><span class="spec-edit-label_icon">🎨</span> Gender Style:</span>
          <div class="preview-theme-selector">
            <button type="button" class="btn-preview-theme ${this.state.gender === 'Boy' ? 'active' : ''}" data-theme="Boy">👦 Boy</button>
            <button type="button" class="btn-preview-theme ${this.state.gender === 'Girl' ? 'active' : ''}" data-theme="Girl">👧 Girl</button>
            <button type="button" class="btn-preview-theme ${this.state.gender === 'Neutral' ? 'active' : ''}" data-theme="Neutral">🌟 Neutral</button>
          </div>
        </div>

        ${hasSoloPhotos ? `
          <div class="spec-row">
            <span class="spec-k">Kid Photos (${this.state.soloPhotos.length}):</span>
            <span class="spec-v">✓ ${this.state.soloPhotos.length} image(s) verified</span>
          </div>
          ${this.state.familyPhotos.length > 0 ? `
            <div class="spec-row">
              <span class="spec-k">Family Photos (${this.state.familyPhotos.length}):</span>
              <span class="spec-v">✓ ${this.state.familyPhotos.length} family image(s) verified</span>
            </div>
          ` : ''}
        ` : ''}

        ${hasRegularPhotos ? `
          <div class="spec-row">
            <span class="spec-k">Attached Photos (${this.state.photos.length}):</span>
            <span class="spec-v">✓ ${this.state.photos.length} image(s) verified</span>
          </div>
        ` : ''}

        ${this.state.audio ? `
          <div class="spec-row">
            <span class="spec-k">Audio Pronunciation:</span>
            <span class="spec-v">🎵 ${this.state.audio.name} (${this.state.audio.duration || '0:00'})</span>
          </div>
        ` : ''}

        ${this.state.childPhoto ? `
          <div class="spec-row">
            <span class="spec-k">Child Photo:</span>
            <span class="spec-v">👶 ${this.state.childPhoto.name}</span>
          </div>
        ` : ''}

        <div class="spec-edit-row">
          <label class="spec-edit-label" for="preview-inline-notes"><span><span class="spec-edit-label_icon">📝</span> Customer Notes:</span></label>
          <textarea id="preview-inline-notes" class="spec-inline-textarea" rows="2" placeholder="Special instructions for production..." maxlength="300">${this.escapeHtml(this.state.notes)}</textarea>
        </div>
      `;

      const inlineNameInput = document.getElementById('preview-inline-name');
      if (inlineNameInput) {
        inlineNameInput.addEventListener('input', (e) => {
          this.state.name = e.target.value;
          const activeCardName = document.getElementById('preview-active-card-name');
          if (activeCardName) activeCardName.textContent = this.state.name || 'Recipient Name';
        });
      }

      table.querySelectorAll('.btn-preview-theme').forEach(btn => {
        btn.addEventListener('click', () => {
          table.querySelectorAll('.btn-preview-theme').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          this.state.gender = btn.getAttribute('data-theme');
          this.renderSampleCanvas();
        });
      });

      const inlineNotesTextarea = document.getElementById('preview-inline-notes');
      if (inlineNotesTextarea) {
        inlineNotesTextarea.addEventListener('input', (e) => {
          this.state.notes = e.target.value;
        });
      }
    }

    /* --------------------------------------------------------------------------
       Direct Cloud Upload & AJAX Cart Submission
       -------------------------------------------------------------------------- */
    async submitToShopifyCart() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      const variantId = this.selectedVariant?.id || this.formVariantInput?.value;
    
      if (!variantId) {
        this.isSubmitting = false;
        alert('Variant not found. Please return to the product page and try again.');
        return;
      }

      const addBtns = [this.btnSampleAddCartTop, this.btnSampleAddCartMain].filter(Boolean);
      addBtns.forEach(btn => {
        btn.disabled = true;
        btn.innerHTML = '<span>⏳ Preparing Files...</span>';
      });

      const properties = {
        'Personalized Name': this.state.name,
        'Gender': this.state.gender,
        'Customer Notes': this.state.notes || 'None'
      };

      try {
        // 1. Upload Photos (noaudionew / audioimage / cards)
        if (this.state.photos.length > 0) {
          for (let i = 0; i < this.state.photos.length; i++) {
            const photoObj = this.state.photos[i];
            addBtns.forEach(btn => {
              btn.innerHTML = `<span>⏳ Uploading Photo ${i + 1} of ${this.state.photos.length}...</span>`;
            });
            const cloudUrl = await uploadFileToCloud(photoObj.file, 'image');
            properties[`Photo #${i + 1}`] = cloudUrl;
          }
        }

        // 2. Upload Kid Photos (noaudiofamily / mealtime)
        if (this.state.soloPhotos.length > 0) {
          for (let i = 0; i < this.state.soloPhotos.length; i++) {
            const soloObj = this.state.soloPhotos[i];
            addBtns.forEach(btn => {
              btn.innerHTML = `<span>⏳ Uploading Kid Photo ${i + 1} of ${this.state.soloPhotos.length}...</span>`;
            });
            const cloudUrl = await uploadFileToCloud(soloObj.file, 'image');
            properties[`Kid Photo #${i + 1}`] = cloudUrl;
          }
        }

        // 3. Upload Family Photos (noaudiofamily / mealtime)
        if (this.state.familyPhotos.length > 0) {
          for (let i = 0; i < this.state.familyPhotos.length; i++) {
            const famObj = this.state.familyPhotos[i];
            addBtns.forEach(btn => {
              btn.innerHTML = `<span>⏳ Uploading Family Photo ${i + 1} of ${this.state.familyPhotos.length}...</span>`;
            });
            const cloudUrl = await uploadFileToCloud(famObj.file, 'image');
            properties[`Family Photo #${i + 1}`] = cloudUrl;
          }
        }

        // 4. Upload Child Photo (Bespoke)
        if (this.state.childPhoto && this.state.childPhoto.file) {
          addBtns.forEach(btn => { btn.innerHTML = '<span>⏳ Uploading Child Photo...</span>'; });
          const childCloudUrl = await uploadFileToCloud(this.state.childPhoto.file, 'image');
          properties['Child Photo'] = childCloudUrl;
        }

        // 5. Upload Spoken Audio Pronunciation (audionew / audioimage)
        if (this.state.audio && this.state.audio.file) {
          addBtns.forEach(btn => { btn.innerHTML = '<span>⏳ Uploading Spoken Audio...</span>'; });
          const audioCloudUrl = await uploadFileToCloud(this.state.audio.file, 'video');
          properties['Pronunciation Audio'] = audioCloudUrl;
        }

        addBtns.forEach(btn => { btn.innerHTML = '<span>⏳ Adding to Cart...</span>'; });

        const payload = {
          items: [{
            id: parseInt(variantId, 10),
            quantity: 1,
            properties: properties
          }],
          sections: 'cart-drawer,cart-icon-bubble'
        };

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });

        const data = await response.json();

        if (response.ok) {
          addBtns.forEach(btn => {
            btn.innerHTML = '<span>✓ Added to Cart!</span>';
            setTimeout(() => {
              btn.innerHTML = '<span>Add to Cart & Continue →</span>';
              btn.disabled = false;
              this.isSubmitting = false;
            }, 2500);
          });

          // Open Dawn Cart Drawer
          const cartDrawer = document.querySelector('cart-drawer');
            if(variantId == '57726513480006')
            {
                window.location.href = '/checkout';
            }
            else
            {
                    if (cartDrawer) {
                if (data.sections && data.sections['cart-drawer']) {
                  const parser = new DOMParser();
                  const parsedDoc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
                  const newInner = parsedDoc.querySelector('#CartDrawer') || parsedDoc.querySelector('.drawer__inner') || parsedDoc.querySelector('.cart-drawer');
                  const currentInner = cartDrawer.querySelector('#CartDrawer') || cartDrawer.querySelector('.drawer__inner') || cartDrawer.querySelector('.cart-drawer');
                  if (newInner && currentInner) currentInner.innerHTML = newInner.innerHTML;
                }

                if (data.sections && data.sections['cart-icon-bubble']) {
                  const iconBubble = document.getElementById('cart-icon-bubble');
                  if (iconBubble) iconBubble.innerHTML = data.sections['cart-icon-bubble'];
                }

                cartDrawer.classList.remove('is-empty');

                if (typeof cartDrawer.open === 'function') {
                  cartDrawer.open();
                } else {
                  cartDrawer.classList.add('active', 'animate');
                  document.body.classList.add('overflow-hidden');
                }

                if (window.Shopify && window.Shopify.PubSub && window.PUB_SUB_EVENTS) {
                  Shopify.PubSub.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-personalizer' });
                }
              } else {
                window.location.href = '/cart';
              }
            }
        
        } else {
          this.isSubmitting = false;
          addBtns.forEach(btn => {
            btn.disabled = false;
            btn.innerHTML = '<span>Add to Cart & Continue →</span>';
          });
          alert(data.description || data.message || 'Could not add item to cart. Please try again.');
        }
      } catch (err) {
        this.isSubmitting = false;
        console.error('Cloud Upload / Cart error:', err);
        addBtns.forEach(btn => {
          btn.disabled = false;
          btn.innerHTML = '<span>Add to Cart & Continue →</span>';
        });
        alert('Upload encountered an error. Please try again.');
      }
    }

    escapeHtml(text) {
      if (!text) return '';
      return text.replace(/[&<>"']/g, function(m) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' };
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new ShopifyProductPersonalizer();
  });
})();
